import { useState } from "react";
import ReModal from "../../unity-ui-common/Components/ReModal";
import { file } from "../../API/File";
import { Alert, Button, Divider, Result } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import * as Styles from "./ImportUserContactListModalStyles";
import ReUpload from "../../unity-ui-common/Components/ReFormFields/ReUpload";
import { user } from "../../API/UserManagement/User";
import { useEffect } from "react";
import { tenant } from "../../API/UserManagement/Tenant";
import { loadState } from "../../sessionstorage";
import { auth } from "../../API/Auth";
import ReSelect from "../../unity-ui-common/Components/ReFormFields/ReSelect";

interface IProps {
  visibility: boolean;
  setVisibility: Function;
  // getTableData: Function;
  isImported: boolean;
  setIsImported: Function;
  isFileUploded: boolean;
  setIsFileUploded: Function;

  setCommonRefresh: React.Dispatch<React.SetStateAction<boolean>>


}

function ImportUserContactListModal(props: IProps) {
  const {
    visibility,
    setVisibility,
    // getTableData,
    isImported,
    setIsImported,
    isFileUploded,
    setIsFileUploded,
    setCommonRefresh

  } = props;

  const [importButtonLoading, setImportButtonLoading] =
    useState<boolean>(false);
  const [response, setResponse] = useState({
    imported: 0,
    updated: 0,
    duplicate: 0,
    failed: 0,
    total: 0,
    errors: [] as string[],
  });
  const [importError, setImportError] = useState<{ message: string; rows: string[] } | null>(null);
  const [attachmentFormData, setAttachmentFormData] = useState({});
  const [attachmentList, setAttachmentList] = useState<any>([]);
  const [allSponsors, setAllSponsors] = useState<any>([]);
  const [selectedTargetTenant, setSelectedTargetTenant] = useState<string[]>([]);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    const getSponsors = async () => {
      const res = await tenant.getAll();
      setAllSponsors(Array.isArray(res) ? res : []);
    };
    getSponsors();

    const sessionData = loadState()?.session?.userData;
    const privileges = auth.getUsersPrivileges();
    const hasAdminPermission = privileges.includes("20");

    if (hasAdminPermission) {
      setIsSuperAdmin(true);
    }
  }, []);

  const onBeforeAttachmentUpload = async (fileformData: any) => {
    const filenameArr = fileformData["name"].split(".");
    const file_type = filenameArr[filenameArr.length - 1];

    const res = await file.getUrl(file_type);
    const fileName = filenameArr[0];
    setAttachmentList([fileformData]);
    setImportError(null);
    await file.remoteUploadFile(res.url, fileformData);

    setAttachmentFormData({
      fileUID: fileformData.uid,
      id: res.id,
      filename: fileName,
      file_type,
    });
    setIsFileUploded(true);
  };

  const handleAttachmentFileRemove = (fileformData: any) => {
    const index = attachmentList.indexOf(fileformData);
    const newFileList = attachmentList.slice();
    newFileList.splice(index, 1);
    setAttachmentList(newFileList);
    setAttachmentFormData({});
    setIsFileUploded(false);
    setImportError(null);
  };

  // The server answers a failed import with { status: false, error, errors? };
  // a request rejected before it reaches the import (e.g. a 413) carries Nest's
  // { statusCode, message } instead, and a network failure gives no body.
  const getImportError = (res: any) => {
    if (!res) {
      return { message: "Could not reach the server. Please check your connection and try again.", rows: [] };
    }
    const message =
      res.statusCode >= 400
        ? [res.message].flat().join(" ")
        : res.error;
    return {
      message: typeof message === "string" && message ? message : "The contact list could not be imported. Please try again.",
      rows: Array.isArray(res.errors) ? res.errors : [],
    };
  };

  function downloadFile() {
    const link = document.createElement("a");
    link.href = "/Assets/Templates/template2.xlsx";
    link.download = "Contact List Template";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleSubmit = async () => {
    setCommonRefresh(false)
    setImportButtonLoading(true);
    setImportError(null);
    // if (!safetyDocumentID) throw new Error("Report ID not found");
    try {
      const res = await user.import(
        // safetyDocumentID,
        attachmentList[0],
        attachmentFormData,
        isSuperAdmin && selectedTargetTenant.length > 0 ? selectedTargetTenant : undefined
      );
      if (res?.status === true) {
        setResponse({ ...res, errors: res.errors || [] });
        setIsImported(true);
      } else {
        setImportError(getImportError(res));
      }
    } catch (err) {
      setImportError(getImportError(undefined));
    } finally {
      setCommonRefresh(true)
      setImportButtonLoading(false);
    }

    // getTableData();

  };

  return (
    <ReModal
      width={600}
      title="Import Contact List"
      visibility={visibility}
      onCancel={() => {
        setImportError(null);
        setVisibility(false);
      }}
      footer={false}
    >
      <Styles.ModalBody>
        {!isImported && (
          <>
            <Button
              type="link"
              onClick={downloadFile}
              icon={<DownloadOutlined />}
            >
              Download Contact List Template
            </Button>
            <Divider />
          </>
        )}
        {isImported ? (
          <Result
            status={response?.failed ? "warning" : "success"}
            title={
              response?.failed
                ? "Contact List Imported With Some Rows Skipped"
                : "Contact List Imported Successfully"
            }
            subTitle={
              <>
                <strong>{response?.imported} New Contacts</strong> were imported,{" "}
                <strong>{response?.updated} Contacts</strong> updated,{" "}
                <strong>{response?.duplicate} duplicate records</strong>{" "}
                detected
                {!!response?.failed && (
                  <>
                    , <strong>{response.failed} rows skipped</strong>
                  </>
                )}
                , <strong>total contacts were {response?.total} </strong>
                {!!response?.errors?.length && (
                  <Alert
                    style={{ marginTop: "1rem" }}
                    type="warning"
                    message="These rows were not imported:"
                    description={
                      <Styles.ErrorList>
                        {response.errors.map((rowError) => (
                          <li key={rowError}>{rowError}</li>
                        ))}
                      </Styles.ErrorList>
                    }
                  />
                )}
              </>
            }
            extra={[
              <Button
                onClick={async () => {
                  setAttachmentList([]);
                  setIsImported(false);
                  setIsFileUploded(false);
                  setVisibility(false);
                }}
              >
                Done
              </Button>,
            ]}
          />
        ) : (
          <>
            {isSuperAdmin && (
              <div style={{ marginBottom: "1rem" }}>
                <p>Sponsor/MAH:</p>
                <ReSelect
                  label=""
                  name="selectedTargetTenant"
                  // type="multiple"
                  items={allSponsors?.map((sp: any) => ({
                    title: sp.name,
                    value: sp.id,
                    disable: sp.status === 0 || false,
                  }))}
                  onChange={(value: any) => {
                    setSelectedTargetTenant(value);
                  }}
                  textItem="Sponsor/MAH"
                  required
                  searchable
                />
              </div>
            )}
            <ReUpload
              errorMessage="Please enter your file"
              accept=".xlsx"
              label=""
              BtnTitle="Click to Upload File"
              name="attachments"
              onBeforeUpload={onBeforeAttachmentUpload}
              onRemove={handleAttachmentFileRemove}
              fileListMaxCount={1}
              fileList={attachmentList}
            />
            {importError && (
              <Alert
                type="error"
                showIcon
                message={importError.message}
                description={
                  importError.rows.length > 0 && (
                    <Styles.ErrorList>
                      {importError.rows.map((rowError) => (
                        <li key={rowError}>{rowError}</li>
                      ))}
                    </Styles.ErrorList>
                  )
                }
              />
            )}
            {isFileUploded && (
              <Button
                loading={importButtonLoading}
                type="primary"
                onClick={handleSubmit}
              >
                Import
              </Button>
            )}
          </>
        )}
      </Styles.ModalBody>
    </ReModal>
  );
}

export default ImportUserContactListModal;
